document.addEventListener('turbolinks:load', () => {
  let popover = $('.popover');
  if (popover !== null || popover !== undefined) {
    popover.remove();
  }

  $('[data-toggle="popover"]').popover();
});
